/**
 * SASADM-0176 — the one-line text of a problem routing deploy, for the call sites that report
 * by snackbar (the wizard deploy, product delete): PARTIAL names the held-back slugs as plain
 * text; REJECTED / FAILED show the server message.
 */
import type { RoutingDeployOutcome } from '@/api/types';

type CopyFunction = (
  key: string,
  fallback?: string,
  values?: Record<string, string | number>,
) => string;

export function deployProblemText(outcome: RoutingDeployOutcome, t: CopyFunction): string {
  if (outcome.status === 'PARTIAL') {
    const slugs = (outcome.heldBack ?? []).map((h) => h.slug);
    // A tolerant read: PARTIAL without its list shows the server sentence.
    if (slugs.length === 0) {
      return (
        outcome.message ??
        t(
          'routingDeploy.partialTitle',
          'Routing deployed, but some settings were kept on their previous version',
        )
      );
    }
    return t(
      'routingDeploy.partialSnack',
      'Routing deployed, but some settings were kept on their previous version: {{list}}. Fix their settings, then deploy again.',
      { list: slugs.join(', ') },
    );
  }
  return (
    outcome.message ??
    t('routingDeploy.failedNoMessage', 'The edge did not accept the new routing.')
  );
}
